import { __awaiter } from "tslib";
import { listAdapter } from './adapters';
import AjaxUtils from './ajaxUtils';
export const listsAPI = {
    getListsOfCompanies: (companyIds) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/companies/lists', { companyIds }); }),
    getListsOfContacts: (queryParams) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `${envConfig.OUTBOUND_SEARCH_URL}/api/v1/lists?${queryParams}`;
        const results = yield AjaxUtils.get(url, true);
        return results === null || results === void 0 ? void 0 : results.lists.map(listAdapter);
    }),
    createList: (data) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/lists', data); }),
};
